(function () {
  'use strict';

  angular.module('unit.cancel.deal').factory('UnitCancelDeal', UnitCancelDeal);

  UnitCancelDeal.$inject = ['$resource'];

  function UnitCancelDeal($resource) {
    return $resource(
      '/api/',
      {},
      {
        cancelDeal: { method: 'POST', url: '/api/deal/:id/cancel' },
        getCancelCustomFields: {
          method: 'GET',
          url: '/api/deal/cancel_custom_fields',
          isArray: true,
          cache: true,
        },
      },
    );
  }
})();
